import { atlasRoutes } from "@/app/router/routes";
import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { Button } from "@radix-ui/themes";
import { useQuery } from "@tanstack/react-query";

import { FC, useCallback } from "react";
import { useNavigate, useParams } from "react-router";

export const DataImportsViewPage: FC = () => {
  const { dataImportId } = useParams<{ dataImportId: Uuid }>();
  const navigate = useNavigate();

  if (!dataImportId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["data-import-by-id", dataImportId],
    queryFn: () =>
      api.get("/internal/v1/data-imports/{data_import_id}", {
        params: {
          path: {
            data_import_id: dataImportId,
          },
        },
      }),
  });

  const onTemporalLinkClick = useCallback(async () => {
    const spaceAccountId = result.data?.data?.owned_by_space_account_id;

    if (!spaceAccountId) {
      return;
    }

    const spaceAccountResult = await api.get("/internal/v1/space-accounts/{space_account_id}", {
      params: {
        path: {
          space_account_id: spaceAccountId,
        },
      },
    });

    const accountId = spaceAccountResult?.data?.account_id;

    if (!accountId) {
      alert("No matching space account found");
      return;
    }

    window.open(
      `https://cloud.temporal.io/namespaces/prod-backend-async-worker.rqp4d/workflows?query=%60WorkflowId%60+STARTS_WITH+%22ImportV1AccountContentToV2Workflow-AccountContent-${accountId}%22`,
      "_blank"
    );
  }, [result.data]);

  return (
    <div>
      <h1>View Data Import</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
      <Button
        variant="outline"
        onClick={() =>
          navigate(atlasRoutes.dataImportDataImportItems({ params: { dataImportId } }).path)
        }
      >
        View Data Import Items
      </Button>
      <br />
      <Button variant="outline" onClick={onTemporalLinkClick}>
        View Temporal
      </Button>
    </div>
  );
};
